import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const ShopifyIconAtom = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 51 51">
			<path
				fill="none"
				stroke="#070F2B"
				strokeWidth={3}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M27.455 4.80241L41.2888 12.2612C42.9038 13.1324 42.9038 15.6187 41.2888 16.4899L27.455 23.9487C26.2225 24.6074 24.7775 24.6074 23.545 23.9487L9.71125 16.4899C8.09625 15.6187 8.09625 13.1324 9.71125 12.2612L23.545 4.80241C24.7775 4.14366 26.2225 4.14366 27.455 4.80241Z"
			/>

			<g opacity={0.4}>
				<path
					fill="none"
					stroke="#070F2B"
					strokeWidth={3}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M7.67125 21.5263L20.5275 27.9651C22.1212 28.7726 23.1413 30.4088 23.1413 32.1938V44.3488C23.1413 46.1126 21.2925 47.2388 19.72 46.4526L6.86375 40.0138C5.27 39.2063 4.25 37.5701 4.25 35.7851V23.6301C4.25 21.8663 6.09875 20.7401 7.67125 21.5263Z"
				/>

				<path
					fill="none"
					stroke="#070F2B"
					strokeWidth={3}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M43.3286 21.5263L30.4724 27.9651C28.8786 28.7726 27.8586 30.4088 27.8586 32.1938V44.3488C27.8586 46.1126 29.7074 47.2388 31.2799 46.4526L44.1361 40.0138C45.7299 39.2063 46.7499 37.5701 46.7499 35.7851V23.6301C46.7499 21.8663 44.9011 20.7401 43.3286 21.5263Z"
				/>
			</g>
		</SvgIcon>
	)
}

export default ShopifyIconAtom
